// API Configuration Helper
const config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://apiw.cloud.medianetsolutions.my.id',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://apiw.cloud.medianetsolutions.my.id/api',
  ENV: process.env.REACT_APP_ENV || 'production'
};

// Helper functions for API endpoints
export const getApiUrl = (endpoint = '') => {
  const baseUrl = config.API_URL;
  if (endpoint.startsWith('/')) {
    return `${baseUrl}${endpoint}`;
  }
  return endpoint ? `${baseUrl}/${endpoint}` : baseUrl;
};

export const getApiBaseUrl = (endpoint = '') => {
  const baseUrl = config.API_BASE_URL;
  if (endpoint.startsWith('/')) {
    return `${baseUrl}${endpoint}`;
  }
  return endpoint ? `${baseUrl}/${endpoint}` : baseUrl;
};

export default config;
